import React from 'react';
import { Form, Input } from 'antd';

export default function ActivityForm({ form, initialValues }) {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <Form.Item
        name="name"
        label="Name"
        rules={[
          {
            required: true,
            whitespace: true,
            message: 'Enter an activity name',
          },
        ]}
        extra="Shown on shift cards and used when linking a timer to a shift."
      >
        <Input autoFocus placeholder="e.g. Phone Answering" maxLength={80} />
      </Form.Item>
      <Form.Item
        name="color"
        label="Color"
        extra="Used as the accent on weekly board shift cards."
      >
        <input
          type="color"
          aria-label="Activity color"
          style={{
            width: 56,
            height: 36,
            padding: 2,
            border: '1px solid #d9d9d9',
            borderRadius: 6,
            cursor: 'pointer',
            verticalAlign: 'middle',
            background: '#fff',
          }}
        />
      </Form.Item>
    </Form>
  );
}
